import { render, staticRenderFns } from "./TopicHeader.vue?vue&type=template&id=17eb4257&scoped=true&"
import script from "./TopicHeader.vue?vue&type=script&lang=js&"
export * from "./TopicHeader.vue?vue&type=script&lang=js&"
import style0 from "./TopicHeader.vue?vue&type=style&index=0&id=17eb4257&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17eb4257",
  null
  
)

export default component.exports